import styled from "styled-components";

export const WrapperPublicPlace = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 16px;
    gap: ${props => props.theme.gaps.small};
    width: 100%;
    border: ${props => props.standard === "S" ? props.theme.border.small_red2 : '1.5px solid #999999'} ;
    border-radius: 20px;
    flex-wrap: wrap;
    

    p{  
        font-weight: ${props => props.theme.font_weight.large};
        font-size: ${props => props.theme.font_size.very_small};
        line-height: ${props => props.theme.lines_height.small};
        color:  ${props => props.standard === "S" ? props.theme.colors.red2 : props.theme.colors.gray2 } ;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

`;
